import { Component} from '@angular/core'; 
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';  
import { AuthService } from '../../_services';
import { LoaderService } from '../../_services/loader.service'; 
import { process, State} from '@progress/kendo-data-query'; 
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings,DataStateChangeEvent,GridDataResult} from '@progress/kendo-angular-grid'; 
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import * as _moment from 'moment';  
import * as _rollupMoment from 'moment'; 
const moment = _rollupMoment || _moment;  
declare var $: any; 
import Swal from 'sweetalert2'

const distinctVehicleCat = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VEHCATNAME === x.VEHCATNAME) === idx);
const distinctVehicleType = data => data.filter((x, idx, xs) => xs.findIndex(y => y.VEHTYPNAME === x.VEHTYPNAME) === idx); 
const distinctWard = data => data.filter((x, idx, xs) => xs.findIndex(y => y.WARDNAME === x.WARDNAME) === idx); 
const distinctZone = data => data.filter((x, idx, xs) => xs.findIndex(y => y.ZONENAME === x.ZONENAME) === idx); 
const distinctStatus = data => data.filter((x, idx, xs) => xs.findIndex(y => y.maintStatus === x.maintStatus) === idx); 


@Component({ 
    selector: 'km-cmp',
    templateUrl: './km.component.html',  
})

export class KMEntriesComponent { 
    prjId:any;  
    showLoader:boolean; 
    startDate:any;
    endDate:any;
    defStartDt:any;
    defEndDt:any;
    dateRange:any; 
    vehKmReport:any
    public state: State = {  
        skip: 0,
        take: 20, 
        filter: {
            logic: 'and',
            filters: []
        }
    };
    public pageSize :any
    public checkboxOnly = false;
    public mode = 'multiple';
    public selectableSettings: SelectableSettings;
    driverHistoryData: any;
    vehicleMaintHistory: any;
    loader: boolean = false;
    hasNoData: boolean = false;
    vehno: any;
    vehKMData: any;
    startKM: any;
    endKM: any;
    success: boolean = false;
    error: boolean = false;
    vehId: any;
    startIsNotNull: boolean;
    total: any;
    driversData: any;
    authtoken: any;
    showHideStaffAssignLoadDiv: boolean;
    imageStaffAssignLoader: string;
    vehStaffNameModel: string;
    vehStaffAsignStatus: Object;
    currentDate: Date;
    activeStatus: string;
    userId: any;
    currentDriver: any;
    checked: boolean = false;
    driverMapID: any;
    previousOpening: any;
    previousClosing: any;
    firstEntry: boolean = true;
    startKMid: any;
    firstEntryEnd: boolean = true;
    info: boolean;
    driverSaveBtn: boolean;
    manual: boolean;
    KMID: any;
    hasAnyEntry: boolean;
    public allData(): ExcelExportData {
        const result: ExcelExportData =  {
            data: this.vehKmReport
        };
        return result;
    } 
    public groups: GroupDescriptor[] = [];
    public view: Observable<GridDataResult>; 
    public gridDataMileageReport: DataResult;
    public groupChange(groups: GroupDescriptor[]): void {
        this.groups = groups;
        this.loadProducts();
    } 
    public distinctVehicleCat: any[]
    public distinctVehicleType: any[]
    public distinctZone: any[]
    public distinctWard: any[]
    public distinctStatus: any[]
    public date = moment();
    private loadProducts(): void {
        this.gridDataMileageReport = process(this.vehKmReport, { group: this.groups });  
    }

    constructor(
        private http : HttpClient,
        private auth : AuthService,
        public routes: ActivatedRoute,
        public router: Router,
        private loaderService: LoaderService
    ){
        this.loaderService.status.subscribe((val: boolean) =>{this.showLoader = val;});
        this.authtoken = JSON.parse(localStorage.getItem('authData'));
        this.allData = this.allData.bind(this);
        var date = new Date();  
        this.defStartDt = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate(); 
        this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
        this.dateRange= {beginDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()},endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}}; 
    }  
  

    /*
    * get Fuel Report List
    */ 
    getVehicleKilometers(){   
        this.loaderService.display(true);  
        this.http.get(environment.apiUrl + 'admin/getVehiclesKM?prjid='+this.prjId+'&startDate='+this.startDate+'&endDate='+this.endDate).subscribe(data =>{ 
            this.vehKmReport=data; 
            if(this.vehKmReport.length>0){  
                this.distinctVehicleCat = distinctVehicleCat(this.vehKmReport) 
                this.distinctVehicleType = distinctVehicleType(this.vehKmReport) 
                this.distinctWard = distinctWard(this.vehKmReport) 
                this.distinctZone = distinctZone(this.vehKmReport) 
                this.distinctStatus = distinctStatus(this.vehKmReport) 
                this.gridDataMileageReport = process(this.vehKmReport, this.state);
                this.loaderService.display(false); 
            }else{
                this.loaderService.display(false); 
                this.gridDataMileageReport=null;
            } 
        });  
    } 

    /*
    * filter The Grid Data
    */
    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.gridDataMileageReport = process(this.vehKmReport, this.state);  
        if (state && state.group) { 
            this.distinctVehicleCat = distinctVehicleCat(this.vehKmReport) 
            this.distinctVehicleType = distinctVehicleType(this.vehKmReport) 
            this.distinctZone = distinctZone(this.vehKmReport) 
            this.distinctWard = distinctWard(this.vehKmReport) 
            this.distinctStatus = distinctStatus(this.vehKmReport) 
            this.gridDataMileageReport = process(this.vehKmReport, this.state); 
        } 
    } 

    /*
    *select start Date Nad To date
    */
    onDateRangeChanged(dataRange){  
        if(dataRange.beginDate.day>0){ 
            this.startDate= dataRange.beginDate.year + "-"  + dataRange.beginDate.month+ "-" + dataRange.beginDate.day 
            this.endDate = dataRange.endDate.year + "-"  + dataRange.endDate.month  + "-" + dataRange.endDate.day 
            this.getVehicleKilometers(); 
        }
        else if(dataRange.beginDate.day==0){
            this.startDate= this.defStartDt
            this.endDate = this.defEndDt
            this.getVehicleKilometers(); 
        }  
    } 

    updateEntry(data){
        this.clearData()
        this.loader = true
        this.hasNoData = false
        this.vehno = data.VEHNO
        this.vehId = data.id
        this.fetchVehKMS()
        this.fetchVehDriver()
        this.getDriversList()
        $("#updateEntryModal").modal("show");
    }

    fetchVehKMS(){
        // var date = moment(this.date).format('YYYY-MM-DD hh:mm:ss')
        this.http.get(environment.apiUrl + 'admin/getVehKms?id=' + this.vehId ).subscribe((data) => {
            var vehKMData: any
            vehKMData = data;
            
			if(vehKMData.length > 0){
                this.vehKMData = vehKMData[vehKMData.length - 1]
                this.previousOpening = this.vehKMData.startKM
                this.previousClosing = this.vehKMData.endKM
                this.loader = false
                this.hasNoData = false
                // this.firstEntry = false
            }else {
                this.startKM = 0
                this.endKM = 0
                // this.firstEntry = true
                this.loader = false
                this.hasNoData = true
            }
		});
        this.http.get(environment.apiUrl + 'admin/currentKMData?id=' + this.vehId + '&date=' + this.endDate ).subscribe((data) => {
            var currentKMData: any
            currentKMData = data;
            
			if(currentKMData.length > 0){
                if (currentKMData[0].endKM == "0") {
                    this.loader = false
                    this.hasNoData = false
                    this.firstEntry = false
                    this.firstEntryEnd = true
                    this.info = false
                    this.driverSaveBtn = false
                    this.startKM = currentKMData[0].startKM
                    this.startKMid = currentKMData[0].id
                } else {
                    this.loader = false
                    this.hasNoData = false
                    this.firstEntry = false
                    this.firstEntryEnd = false
                    this.info = true
                    this.driverSaveBtn = true
                    this.startKM = currentKMData[0].startKM
                    this.endKM = currentKMData[0].endKM
                }
            }else {
                this.startKM = 0
                this.endKM = 0
                this.startKMid = null
                this.firstEntry = true
                this.firstEntryEnd = true
                this.info = false
                this.driverSaveBtn = false
                this.loader = false
                this.hasNoData = true
            }
		});
    }

    fetchVehDriver(){
        // var date = moment(this.date).format('YYYY-MM-DD hh:mm:ss')
        this.http.get(environment.apiUrl + 'admin/getDriverHistory?vehid=' + this.vehId ).subscribe((data) => {
            var vehDriver: any
            vehDriver = data;
            
			if(vehDriver.length > 0){
                var driverDetails = vehDriver.filter(
                    d => d.isAssigned == true
                )
                this.currentDriver = driverDetails.length > 0 ? driverDetails[0].EMPNAME + ' (' +driverDetails[0].EMPCODE+ ')' : 'N/A' 
                this.driverMapID = driverDetails.length > 0 ? driverDetails[0].MAPID : 0
            }
        });
        
    }

    switchState(){
        if (this.info) {
            if(this.checked){
                this.driverSaveBtn = false
            } else {
                this.driverSaveBtn = true
            }
        }
    }

    updateDetails(){
        if(this.startKM == null && this.endKM == null ) return alert("Please Enter KM Details")
        if(this.checked == true && this.vehStaffNameModel == null ) return alert("Please Select A Driver Or Uncheck The Tickmark")
        let url : any
        var data ={
            startKM : this.startKM,
            endKM : this.endKM,
            vehNO : this.vehno,
            vehID : this.vehId,
            date : this.endDate,
            id : this.startKMid
        }

        if (this.firstEntry) {
            url = environment.apiUrl + 'admin/insertKms';
            $("#newEntry").text('New Entry');
        } else {
            url = environment.apiUrl + 'admin/updateKms';
            $("#newEntry").text('Update');
        }
        if(this.firstEntryEnd){
            this.http.post(url, data).subscribe((data) => {
                var updateStatus: any;
                updateStatus = data;
                if (updateStatus.status == 'ok') {
                    this.success = true;
                    setTimeout(() => {
                        this.getVehicleKilometers();
                        this.clearData();
                        $('#updateEntryModal').modal('hide');
                        this.success = false;
                    }, 1000);
                } else {
                    this.error = true;
                    setTimeout(() => {
                        this.getVehicleKilometers();
                        this.clearData();
                        $('#updateEntryModal').modal('hide');
                        this.error = false;
                    }, 1000);
                }
            });
        } else {
            this.info = true
            this.driverSaveBtn = true
        }
        
        if(this.checked){
            this.saveDriver()
        }
    }

    getDriversList = async () => {
        let drivers = await fetch(
            environment.apiUrl + 'admin/getAllStaffNameByRoleId?roleid=5',
            {
                method: 'get',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: this.authtoken.token
                }
            }
        );
        var driversData = await drivers.json();
        driversData.forEach(element => {
            element.empname = element.empname + ' (' + element.EMPCODE + ')'
        });
        this.driversData = driversData
    }

    OnChangeToSelectStaffName() {
        this.showHideStaffAssignLoadDiv = true;
        this.imageStaffAssignLoader = "../../assets/img/loading.gif";
        this.http.get(environment.apiUrl + 'admin/getVehicalStaffAssignAvailability?VEHID=' + this.vehId + '&EMPROLEMAPID=' + this.vehStaffNameModel).subscribe((data) => {
            this.vehStaffAsignStatus = data;
            if (this.vehStaffAsignStatus[0].result == "Available") {
                this.showHideStaffAssignLoadDiv = true;
                this.imageStaffAssignLoader = "../../assets/img/ok.png";
            }
            if (this.vehStaffAsignStatus[0].result == "Already exists") {
                this.showHideStaffAssignLoadDiv = true;
                this.imageStaffAssignLoader = "../../assets/img/wrong.jpg";
            }
        });
    }

    saveDriver() {
        this.deleteDriverFirst()
        this.currentDate = new Date();
        this.loaderService.display(true);
        var jsonAreaEntityData = {
            "VEHID": this.vehId,
            "EMPROLEMAPID": this.vehStaffNameModel,
            "ASSIGNDT": this.currentDate,
            "ISACTIVE": 1,
            "ENTRYDT": this.currentDate,
            "UPDATEDBY": this.userId
        }
        // console.log("staff array",jsonAreaEntityData)
        this.http.post(environment.apiUrl + 'admin/saveVehStaffNameDetails', jsonAreaEntityData).subscribe((data) => {
            var staffAssignData: any
            staffAssignData = data;
            if (staffAssignData.status == "ok") {
                this.success = true
                setTimeout(() => {
                this.showHideStaffAssignLoadDiv = false;
                this.success = true
                this.vehStaffNameModel = null;
                this.loaderService.display(false);
                }, 1000);
            } else {
                this.loaderService.display(false);
            }
        });

    }

    deleteDriverFirst(){
        this.http.get(environment.apiUrl + 'admin/deleteVehicleStaffEntityDetails?id=' + this.driverMapID).subscribe((data) => {});
    }

    viewDriverHistory(data){
        this.loader = true
        this.hasNoData = false
        this.http.get(environment.apiUrl + 'admin/getDriverHistory?vehid=' + data.id).subscribe((data) => {
            this.driverHistoryData = data;
            if(this.driverHistoryData.length > 0){
                this.loader = false
                this.hasNoData = false
            }
            else {
                this.loader = false
                this.hasNoData = true
            }
        });
        $("#viewDriverHistory").modal("show");
    }

    viewMaintHistory(data){
        this.loader = true
        this.hasNoData = false
        this.http.get(environment.apiUrl + 'maintenance/getVehicleInfo?ID=' + data.id).subscribe((data) => {
			this.vehicleMaintHistory = data;
			if(this.vehicleMaintHistory.length > 0){
                this.loader = false
                this.hasNoData = false
                this.vehicleMaintHistory.forEach(function (value) {
                    value.total_amount = (value.total_amount == null) ? 0 : (value.total_amount == '') ? 0 : parseInt(value.total_amount,10);
                });
                this.total = this.vehicleMaintHistory.map(item => parseInt(item.total_amount, 10)).reduce((prev, curr) => prev + curr, 0);
            }else {
                this.loader = false
                this.hasNoData = true
            }
		});
        $("#viewMaintHistory").modal("show");
    }

    clearData(){
        this.checked = false
        this.success = false
        this.error = false
        this.firstEntry = true
        this.firstEntryEnd = true
        this.showHideStaffAssignLoadDiv = false
        this.currentDriver = null
        this.vehno = null
        this.startKM = null
        this.endKM = null
        this.vehStaffNameModel = null
        this.startKMid = null
        this.previousClosing = null
        this.previousOpening = null
    }

    clearManualData(){
        this.endKM = null
        this.startKM = null
        this.vehId = null
        this.KMID = null
        this.hasAnyEntry = false
    }
    
    onSelect(data){
        console.log(data.dataItem);
        this.clearManualData()
        this.endKM = data.dataItem.CLOSING
        this.startKM = data.dataItem.OPENING
        this.vehId = data.dataItem.id
        this.KMID = data.dataItem.KMID
        this.manual = true
        this.hasAnyEntry = this.KMID ? true : false
        $('#updateModal').modal('show');
    }

    updateManually(){
        var obj ={
            endKM : this.endKM,
            startKM : this.startKM,
            vehID : this.vehId,
            ID : this.KMID,
            manual : true
        }
        Swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Update it!'
        })
        .then((result) => {
            if (result.value) {
                this.http.post(environment.apiUrl + 'admin/updateKms', obj).subscribe((data) => {
                var result: any
                    result = data
                    if (result.status == "ok") {
                        var msg = result.msg
                        Swal(
                            '',
                            msg,
                            'success'
                        )
                        this.getVehicleKilometers()
        
                    } else {
                        var msg = result.msg
                        Swal(
                            msg,
                            'error'
                        )
                        this.getVehicleKilometers()
                    }
                });
            }
        });
        $('#updateModal').modal('hide');
    }

    ngOnInit() {  
        this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
        this.endDate= moment(this.defEndDt).format('YYYY-MM-DD');
        this.prjId = this.auth.getAuthentication().projectId  
        this.userId = this.auth.getAuthentication().id;
        this.getVehicleKilometers();
    } 
}


// WEBPACK FOOTER //
// ./src/app/reports/fleet-report/km.component.ts